// extracted by mini-css-extract-plugin
module.exports = {"tariffs-title":"BusinessTariffs_tariffs-title__HXlny","slider":"BusinessTariffs_slider__Olsu9"};